import {Component, Input} from '@angular/core';
import {Campo} from '../../../models/coleta';
import {UntypedFormControl} from '@angular/forms';
import {PROPRIEDADES} from '../util/constants';
import {AppValidators} from '../util/validators';
import {getDateConfiguration} from '../util/age.validator';
import sub from 'date-fns/sub';
import { TextMaskConfig } from 'angular2-text-mask';
import { format } from 'date-fns';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const dateTypeConstants: any = {
  Y: 'years',
  M: 'months',
};

@Component({
  selector: 'app-input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss']
})

export class InputDateComponent {
  internalCampo: Campo = {};
  placeholder: any;
  name = '';
  datePicker: any;
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd/mm/yyyy');
  
  readonly MASCARA: TextMaskConfig = {
   mask: [ /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/ ],
   pipe: this.autoCorrectedDatePipe,
   guide: false,
   showMask: false
};
  minDate: Date | undefined;
  maxDate: Date | undefined;
  
  @Input()
  currentFormControl: UntypedFormControl = new UntypedFormControl();

  @Input()
  readOnly = false;

  @Input()
  requestFocus = false;

  toDate(value: any): void{

    const date: Date = value.value;

    const formattedDate: string = format(date, 'dd/MM/yyyy');

    this.datePicker = formattedDate;
    this.currentFormControl.setValue(formattedDate);
  }

  @Input()
  set campo(campo: Campo) {
    this.name = campo.codigo || '';
    this.placeholder = 'DD/MM/YYYY';
    this.internalCampo = campo;
    
    const minAge = this.campo.atributos?.find(item => item.propriedade === PROPRIEDADES.PERIODO_MINIMO);
    if (minAge) {
      const {value, type} = getDateConfiguration(minAge.valor);
      this.maxDate = sub(new Date(), {[dateTypeConstants[type] || '']: value});
    }
    const maxAge = this.campo.atributos?.find(item => item.propriedade === PROPRIEDADES.PERIODO_MAXIMO);
    if (maxAge) {
      const {value, type} = getDateConfiguration(maxAge.valor);
      this.minDate = sub(new Date(), {[dateTypeConstants[type] || '']: value});
    }
  }

  get campo(): Campo {
    return this.internalCampo;
  }

  constructor() { }

  isInvalid(): boolean{
    return !!this.currentFormControl?.invalid;
  }

  getErrorMessage(): string {
    return AppValidators.errorMessage(this.currentFormControl);
  }
}